var womensDresses = {
  category: "Women's",
  product: "Dresses",
  sections: [{
      section: {
        title: "Size Chart",
        type: "table",
        header: [
          "Dress",
          "Size",
          "Your Bust",
          "Your Natural Waist",
          "Your Hips"
        ],
        rows: [
          ["XS", "0", "32.5", "25", "35"],
          ["XS", "2", "33.5", "26", "36"],
          ["S", "4", "34.5", "27", "37"],
          ["S", "6", "35.5", "28", "38"],
          ["M", "8", "36.5", "29", "39"],
          ["M", "10", "37.5", "30", "40"],
          ["L", "12", "39", "31.5", "41.5"],
          ["L", "14", "40.5", "33", "43"],
          ["XL", "16", "42", "34.5", "44.5"]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: 'https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_Dress_-_Standard.png?16578',
            title: "Standard:",
            body: "A-Line silhouette and modern feminine fit, with shaping at the waist and hem hitting at the top of the knee."
          }],
          [{
            img: 'https://cdn.shopify.com/s/files/1/0167/5514/files/petite-dresses.png?v=1667509025',
            title: "Petite:",
            body: "1” (2.5 cm) proportionally shorter in body than our Standard Fit to accommodate heights of 5’3” (160 cm) or under."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_-_How_To_Measure.png?14316"
          }],
          [{
            title: "Bust: ",
            body: "Wrap the measuring tape around your chest, under your arm, at the fullest part of the bust, keeping the tape slightly loose."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of your neck to your wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Stand normally and wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Hips: ",
            body: "With your feet together, wrap the measuring tape around the fullest part of your hips/seat, approximately 8\" (20.3 cm) below your natural waist, keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of your thigh, approximately 1\" (2.5 cm) below the crotch, keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};